import React from "react";
import { FaSchool, FaShieldAlt, FaUserCircle } from "react-icons/fa";

const tabIcons = {
  info: FaUserCircle,
  classrooms: FaSchool,
  privacy: FaShieldAlt,
};

export default function ChildDetailsTabs({ tabs, activeTab, onChange }) {
  return (
    <div className="overflow-hidden rounded-[24px] border border-slate-200/80 bg-white p-1.5 shadow-sm dark:border-white/10 dark:bg-white/5" role="tablist">
      <div className="grid gap-1.5 sm:grid-cols-3">
        {tabs.map((tab) => {
          const Icon = tabIcons[tab.id] || FaUserCircle;
          const selected = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => onChange(tab.id)}
              className={`relative inline-flex min-h-[64px] items-center justify-center gap-3 rounded-[18px] px-4 text-base font-semibold transition focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 ${
                selected
                  ? "bg-indigo-50 text-indigo-700 shadow-sm ring-1 ring-indigo-100 dark:bg-indigo-400/15 dark:text-indigo-100 dark:ring-indigo-300/20"
                  : "text-slate-500 hover:bg-slate-50 hover:text-slate-800 dark:text-slate-300 dark:hover:bg-white/10 dark:hover:text-white"
              }`}
            >
              <Icon aria-hidden="true" />
              {tab.label}
              {selected && <span className="absolute inset-x-5 bottom-1.5 h-1 rounded-full bg-indigo-600 dark:bg-indigo-300" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
